module.exports = __webpack_public_path__ + "img/europe.b63bb338.svg";